import { Box, Container, Grid } from "@mui/material";
import { AnimatedBackground } from "components/AnimatedBackground";
import MKTypography from "components/MKTypography";
import CenteredFooter from "examples/Footers/CenteredFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import { TICKER, WEB_APP_LINK } from "utils/constants";

function WebAppPage() {
  return (
    <>
      {/* Navbar */}
      <DefaultNavbar
        routes={[]}
        // action={{
        //   type: "internal",
        //   route: "#",
        //   label: `Buy ${TICKER}`,
        //   color: "primary",
        //   disabled: true,
        // }}
        transparent
        light
      />

      {/* Main Background */}
      <AnimatedBackground
        gradients={[
          ["#4ac29a", "#bdfff3"],
          ["#6ee2f5", "#6454f0"],
        ]}
      >
        <Container sx={{ mt: "10vh", mb: "10vh", textAlign: "center" }}>
          <Grid container spacing={6} justifyContent="center">
            <Grid item xs={12} md={10} mt={5}>
              {/* Title */}
              <MKTypography
                variant="h2"
                fontWeight="bold"
                color="white"
                sx={{
                  mb: 4,
                }}
              >
                Experience FartLab WebApp 💨📱
              </MKTypography>

              {/* Subtitle */}
              <MKTypography
                variant="h5"
                color="white"
                sx={{
                  letterSpacing: 1.5,
                  mb: 0,
                }}
              >
                The AI-powered fart analysis tool, on any device!
              </MKTypography>
            </Grid>

            <Grid item xs={12} md={8}>
              {/* Phone Frame */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "375px", // iPhone size
                    height: "812px", // iPhone size
                    borderRadius: "40px",
                    border: "10px solid black",
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
                    overflow: "hidden",
                    position: "relative",
                    backgroundColor: "#222",
                  }}
                >
                  {/* Iframe (Web App) */}
                  <iframe
                    src={WEB_APP_LINK} // Replace with your Flutter web app URL
                    width="100%"
                    height="100%"
                    style={{
                      border: "none",
                      borderRadius: "30px",
                    }}
                  ></iframe>

                  {/* Speaker & Camera Notch */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "5px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "150px",
                      height: "8px",
                      backgroundColor: "black",
                      borderRadius: "10px",
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>

        {/* Footer */}
        <CenteredFooter light />
      </AnimatedBackground>
    </>
  );
}
export default WebAppPage;
